import React, {Component} from "react";
import {FormattedMessage} from "react-intl";

import withAuthorization from "../../services/Authorization";
import {connect} from "react-redux";
import AppointmentCreationModal from "./AppointmentCreationModal";
import {
  hideAppointmentCreationModal, hideMessageAppointmentCreationModal,
  showAppointmentCreationModal,
  showMessageAppointmentCreationModal
} from "../../actions/createAppointmentActions";
import RoleUtil from "../../services/RoleUtil";
import Tasks from "../overview/Tasks";
import AppointmentMessageCreationModal from "./AppointmentMessageCreationModal";

class CallCenterOverview extends Component {

  onShowAppointmentCreation = () => {
    this.props.showAppointmentModal();
  };

  onShowMessageAppointmentCreation = () => {
    this.props.showMessageAppointmentModal();
  };

  onHideAppointmentCreation = () => {
    this.props.hideAppointmentModal();
  };

  onHideMessageAppointmentCreation = () => {
    this.props.hideMessageAppointmentModal();
  };

  render() {
    const {saveAppointment: {showAppointmentModal}, saveMessageAppointment: {showMessageAppointmentModal}} = this.props;

    return (
      <div>
        <header className="main-header">
          <div className="main-header__left">
            <h1 className="main__title">
              <FormattedMessage id="page.call-center-overview"/>
            </h1>
          </div>
          <div className="main-header__right">
            <div className="row">
              <div className="col-6">
                <button onClick={this.onShowMessageAppointmentCreation} className="btn btn-primary" type="primary">
                  <FormattedMessage id="overview.newMessageButton"/>
                </button>
              </div>
              <div className="col-6">
                <button onClick={this.onShowAppointmentCreation} className="btn btn-primary" type="primary">
                  <FormattedMessage id="overview.newAppointmentButton"/>
                </button>
              </div>
            </div>
          </div>
        </header>
        <div className="main__content">
          <div className="box">
            <Tasks/>
          </div>
        </div>
        {showAppointmentModal &&
          <AppointmentCreationModal visible={showAppointmentModal} onModalClose={this.onHideAppointmentCreation}/>
        }
        {showMessageAppointmentModal &&
          <AppointmentMessageCreationModal visible={showMessageAppointmentModal} onModalClose={this.onHideMessageAppointmentCreation}/>
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  saveAppointment: state.saveAppointment,
  saveMessageAppointment: state.saveMessageAppointment
});

const mapDispatchToProps = dispatch => ({
  showAppointmentModal: () => dispatch(showAppointmentCreationModal()),
  showMessageAppointmentModal: () => dispatch(showMessageAppointmentCreationModal()),
  hideAppointmentModal: () => dispatch(hideAppointmentCreationModal()),
  hideMessageAppointmentModal: () => dispatch(hideMessageAppointmentCreationModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(withAuthorization(CallCenterOverview, [RoleUtil.CALL_CENTER_AGENT]));
